import React from 'react';
import { runningClientSide } from '@benzinga/utils';

interface Props {
  children: React.ReactNode;
}

export const WindowWrapper = ({ children }: Props) => {
  if (runningClientSide()) {
    return <>{children}</>;
  } else {
    return null;
  }
};

export default WindowWrapper;
